module.exports = __webpack_public_path__ + "static/cad-designs15-06f3649f7d15584733e15a56f7613cb1.png";